import Vue from 'vue';
import VueResource from "vue-resource";
import config from '@/config';

Vue.use(VueResource);

config.setapikey();

export const clientService = {
  get,
  save,
}

function get(id) {
    let url = config.api + `/v1/admin/client/get?id=${id}`;
    
    var ret = new Promise(
    function (resolve, reject) {
        Vue.http.get(url).then(res => {
        resolve(res.body);
        }, err => {
        reject({
            error: true,
            msg: err
        });
        });
    }
  );
  return ret;
}

function save(
    loggedId, 
    id, 
    email, 
    ddd_celular, 
    celular, 
    in_recebe_info, 
    in_recebe_sms, 
    in_concorda_termos, 
    ds_nome, 
    ds_sobrenome, 
    dt_nascimento, 
    ds_ddd_telefone, 
    ds_telefone, 
    cd_rg, 
    cd_cpf, 
    ds_endereco, 
    ds_compl_endereco, 
    ds_bairro, 
    ds_cidade, 
    cd_cep, 
    id_estado, 
    in_sexo, 
    nr_endereco,
    is_disabled
) {
    let url = config.api + `/v1/admin/client/save`;

    let obj = {
        loggedId,
        id: id !== undefined && id !== null ? id : '',
        email,
        ddd_celular,
        celular,
        in_recebe_info,
        in_recebe_sms,
        in_concorda_termos,
        ds_nome,
        ds_sobrenome,
        dt_nascimento,
        ds_ddd_telefone,
        ds_telefone,
        cd_rg,
        cd_cpf,
        ds_endereco,
        ds_compl_endereco,
        ds_bairro,
        ds_cidade,
        cd_cep,
        id_estado,
        in_sexo,
        nr_endereco,
        is_disabled
    };

    return new Promise((resolve, reject) => {
        Vue.http.post(url, obj, { emulateJSON: true }).then(
            res => resolve(res.body),
            err => reject({ error: true, msg: err })
        );
    });
}

